import { render, staticRenderFns } from "./VideoCategoryProductItemRelation.vue?vue&type=template&id=c557c314&scoped=true&"
import script from "./VideoCategoryProductItemRelation.vue?vue&type=script&lang=js&"
export * from "./VideoCategoryProductItemRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c557c314",
  null
  
)

component.options.__file = "VideoCategoryProductItemRelation.vue"
export default component.exports